import { render, staticRenderFns } from "./AppBackground.vue?vue&type=template&id=21e3538a&"
import script from "./AppBackground.vue?vue&type=script&lang=js&"
export * from "./AppBackground.vue?vue&type=script&lang=js&"
import style0 from "./AppBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports